<script>
    import { onMount } from "svelte";
    import { Section, Menu, FloatingMenu } from "@/components";
    import { loadSettingsSections } from "../../../contracts";
    import { goTo } from "@/utils/router";

    import { goingForward } from "@/utils/swipe";

    // fly direction según goingForward
    let flyParams = {
        x: goingForward === null ? 0 : goingForward ? 300 : -300,
        duration: 300,
    };

    let currentRoute = "settings"; // Ruta actual del menú flotante
    let sections = $state([]);

    onMount(async () => {
        sections = await loadSettingsSections();
    });
</script>

<div class="settings">
    {#snippet section()}
        <Menu {sections} />
    {/snippet}

    <Section
        headerText="Settings"
        returnBtn={false}
        actionBack="dashboard"
        {section}
        toast={false}
    />
</div>

<style lang="scss">
    @use "./styles/index.scss";
</style>
